module.exports = __webpack_public_path__ + "img/17.a1003aa2.jpg";